
import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import { message } from 'ant-design-vue';
import numeral from 'numeral';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons-vue';
import {
  getAllCustomerCompany,
  addToCart,
  getAllVehicleColorList
} from '@/api/apis';
import { validateQuantity } from '@/utils/validate';

export default defineComponent({
  name: 'AddToCartModal',
  components: {
    MinusOutlined,
    PlusOutlined
  },
  props: {
    vehicle: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    }
  },
  emits: ['after-close'],
  data() {
    return {
      validateQuantity,
      loading: false,
      visible: true,
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      form: {
        quantity: '1',
        consignee: undefined,
        color: undefined
      },
      title: this.$t('vehicle.form_title'),
      consigneeDropdownList: [],
      colorDropdownList: []
    };
  },
  computed: {
    ...mapState(['userInfo'])
  },
  methods: {
    handleAfterClose() {
      this.$emit('after-close');
    },
    async loadDropdownData() {
      const res = await Promise.all([
        getAllCustomerCompany({
          customerId: this.userInfo.id
        }),
        getAllVehicleColorList({})
      ]);

      if (res.length === 2 && res.every(s => s.success)) {
        this.consigneeDropdownList = res[0].result || [];
        this.colorDropdownList = res[1].result || [];
      }
    },
    substract() {
      const quantity = Number(this.form.quantity);
      if (!isNaN(quantity) && quantity > 1) {
        this.form = {
          ...this.form,
          quantity: String(quantity - 1)
        } as any;

        const form = (this.$refs as any).form;

        form.clearValidate('quantity');
      }
    },
    add() {
      this.form = {
        ...this.form,
        quantity: String(Number(this.form.quantity || 0) + 1)
      } as any;
      const form = (this.$refs as any).form;
      form.clearValidate('quantity');
    },
    handleCancel() {
      this.visible = false;
    },
    handleConfirm() {
      const form = (this.$refs as any).form;
      form
        .validate()
        .then(async () => {
          this.loading = true;
          const res = await addToCart({
            ...this.form,
            quantity: numeral(this.form.quantity).value(),
            customerId: this.userInfo.id,
            img: this.vehicle.showImg,
            attributeImg: this.vehicle.attributeImg,
            modelNum: this.vehicle.modelNum,
            name: this.vehicle.vehicleName,
            shoppingType: 1,
            unitPrice: this.vehicle.sellingPrice,
            unit: this.vehicle.unit,
            // 后端做报表用
            vehicleId: this.vehicle.id,
            vehicleType: this.vehicle.vehicleType
          });
          if (res.success) {
            this.handleCancel();

            message.success(this.$t(res.message));
          }

          this.loading = false;
        })
        .catch();
    }
  },
  created() {
    this.loadDropdownData();
  }
});
